var map = {
	"./Loading-Icon.gif": 1201,
	"./app-awareness-phone.png": 402,
	"./app-modal-android@2x.png": 683,
	"./app-modal-iphone@2x.png": 684,
	"./app-promo-banner-background.png": 1202,
	"./box-prices/2-portions.png": 685,
	"./box-prices/2-portions.webp": 686,
	"./box-prices/4-portions.png": 687,
	"./box-prices/4-portions.webp": 688,
	"./box-prices/best-value.png": 689,
	"./box-prices/box-prices-hero.jpg": 785,
	"./box-prices/couples-box.jpg": 1203,
	"./box-prices/family-box.jpg": 1204,
	"./box-prices/four-person-box.jpg": 519,
	"./box-prices/most-popular.png": 690,
	"./box-prices/two-person-box.jpg": 518,
	"./discount-modal-header.jpg": 522,
	"./earn-reward-background.jpg": 1205,
	"./five-recipes/five-recipes.png": 691,
	"./gousto-boxes.jpg": 692,
	"./gousto-welcome-journey-rollover.jpg": 1206,
	"./hungry-for-savings.png": 1207,
	"./menu/FebYouary_desktop.jpg": 1208,
	"./menu/FebYouary_mobile.jpg": 1209,
	"./menu/FebYouary_tablet.jpg": 1210,
	"./menu/default_desktop_no_click.png": 1211,
	"./menu/default_mobile_no_click.png": 1212,
	"./menu/default_tablet_no_click.png": 1213,
	"./menu/spottyTileBorder.png": 693,
	"./my-gousto-pricing-modal.svg": 1214,
	"./pause-osr-modal-bg.jpg": 1215,
	"./product-placeholder.png": 523,
	"./recipe-placeholder.png": 339,
	"./red-rice-pattern.png": 524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 665;